import { closeRing, pointInPolygon } from './geo';
import type { HeatNetwork, Perimeter } from './types';

type Point = GeoJSON.Position;
const bounds = (points: Point[]) => points.reduce(
  (box, p) => [Math.min(box[0], p[0]), Math.min(box[1], p[1]), Math.max(box[2], p[0]), Math.max(box[3], p[1])],
  [Infinity, Infinity, -Infinity, -Infinity],
);
const overlaps = (a: number[], b: number[]) =>
  a[0] <= b[2] && b[0] <= a[2] && a[1] <= b[3] && b[1] <= a[3];
const cross = (a: Point, b: Point, c: Point) =>
  (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);

/** Une intersection de tronçon suffit, même sans sommet du réseau dans le contour. */
export function networkInPerimeter(network: HeatNetwork, perimeter: Perimeter): boolean {
  if (perimeter.kind === 'communes') return network.communes.some((code) => perimeter.communes.includes(code));
  if (perimeter.polygon.length < 3) return false;
  const lines = network.geometry?.type === 'MultiLineString'
    ? network.geometry.coordinates : [network.geometry?.coordinates ?? network.path];
  const ring = closeRing(perimeter.polygon);
  const box = bounds(ring);
  return lines.some((line) => {
    if (!line.length || !overlaps(bounds(line), box)) return false;
    if (pointInPolygon([line[0][0], line[0][1]], perimeter.polygon)) return true;
    for (let i = 1; i < line.length; i++) {
      const a = line[i - 1], b = line[i];
      const segmentBox = bounds([a, b]);
      if (!overlaps(segmentBox, box)) continue;
      for (let j = 1; j < ring.length; j++) {
        const c = ring[j - 1], d = ring[j];
        if (overlaps(segmentBox, bounds([c, d]))
          && cross(a, b, c) * cross(a, b, d) <= 0
          && cross(c, d, a) * cross(c, d, b) <= 0) return true;
      }
    }
    return false;
  });
}
